import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-progress-circle',
    templateUrl: './progress-circle.component.html',
    styleUrls: ['./progress-circle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DecimalPipe]
})
export class ProgressCircleComponent implements OnInit {
  @Input() percentage: number;
  percentageSafe: number;
  constructor() {
    // this.percentage = Math.round(this.percentage);
    if (this.percentage > 100) {
      this.percentageSafe = 100;
    } else if (this.percentage < 0) {
      this.percentageSafe = 0;
    } else {
      this.percentageSafe = Math.round(this.percentage);
    }
  }

  ngOnInit() {
  }

}
